import { makeStyles, styled } from '@material-ui/core/styles'
import { Box, Card } from '@material-ui/core'

export const DraggableItemContainer = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  margin: '6px 0',
  border: '1px solid #e8e8e8',
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
  width: '100%',
  padding: theme.spacing(1.5),
  maxWidth: 'calc(100% - 4px)',
  boxSizing: 'border-box',
  '& .MuiSvgIcon-root': {
    fontSize: '1.4rem',
    color: 'gray',
    margin: theme.spacing(0, 0.1),
  },
}))

export const DurationControls = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '& .MuiIconButton-root': {
    border: '1px solid',
    borderRadius: 20,
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '1.1285714285714284rem',
    },
  },
  '& .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before, & .MuiInput-underline:after':
    {
      borderBottom: 0,
    },
  '& .MuiFormControl-root': {
    marginBottom: theme.spacing(0),
  },
  '& .MuiInput-root': {
    width: 30,
    height: 30,

    '& .MuiInputBase-input': {
      textAlign: 'center',
      padding: '0',
    },
  },
  '& .MuiIconButton-sizeSmall': {
    padding: '0px',
    [theme.breakpoints.down('sm')]: {
      width: 30,
      height: 30,
    },
  },
}))

export const useStyles = makeStyles((theme) => ({
  header: {
    padding: '4px 10px',
    borderBottom: '1px solid #e8e8e8'
  },
  button: {
    margin: theme.spacing(1, 0),
  },
  infoIcon: {
    marginRight: theme.spacing(1),
  },
  deleteButton: {
    padding: 0,
    flexShrink: 0,
  },
  sessionCategoryImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  drillTitle: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))
